import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const DepartmentOfRealEstateProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `RealEstateDepartment/${props.departmentOfRealEstateId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        const url = "RealEstateDepartment";
        await execute({ scope: 'create', url: url, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `RealEstateDepartment/${props.id}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        const url = 'RealEstateDepartment';
        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `RealEstateDepartment/${props.departmentOfRealEstateId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const getAvailableStates = useCallback(async () => {
        const url = 'RealEstateDepartment/AvailableStates';
        await execute({ scope: 'availableStates', url: url, method: 'GET', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData, getAvailableStates };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useDepartmentOfRealEstateStore = () => React.useContext(Context);
